/**
 * @typedef {Object} Modal
 * @property {Element} modalContainer - The modal's dom container
 * @property {() => void} init - Initializes the modal
 * @property {() => void} display - Shows the modal
 * @property {() => void} hide - hides the modal
 * @property {(Element) => void} replace - Replaces the current modal with a new one
 */

/**
 * @typedef ModalInput
 * @property {Element} [modalContainer] - The initial modal dom container
 * @property {() => void} [init] - Optional initializer function that will be called
 * on every replace call
 */

import createElement from "./createElement";
import {fullPageLoadingActive} from "./loading";
import {waitUntil} from "./waitUntil";

/**
 * Creates a replaceable element from an initial dom element
 * and an initializer function
 * @template {ModalInput} T
 * @param {T} inputObject
 * @return T|Modal
 * @deprecated -- Use modal from modals folder
 */
function createModal(inputObject) {
	// Create empty initializer function if missing
	if (!inputObject.init) {
		inputObject.init = function () {
		};
	}

	if (!inputObject.modalContainer) {
		inputObject.modalContainer = createEmptyModal();
	}

	// Add replace function
	inputObject.replace = function (newModal) {
		const oldModalContainer = this.modalContainer;

		// Replace on memory and initialize
		this.modalContainer = newModal;
		this.init();

		// Replace on dom
		oldModalContainer.replaceWith(this.modalContainer);
	}

	// Add loading helpers

	// Initialize for first time
	inputObject.init();

	// Add display and hide helpers
	inputObject.display = function () {
		waitUntil(canDisplayModal, {
			msBetweenAttempts: 50,
		}).then(() => {
			$(this.modalContainer).modal('show');
		})
	}

	inputObject.hide = function () {
		$(this.modalContainer).modal('hide');
	}

	return inputObject;

	/**
	 * Methods
	 */

	function createEmptyModal() {
		const modalsContainer = document.querySelector('.modals')

		const newModal = createElement('<div class="modal fade empty-modal"></div>')

		modalsContainer.appendChild(newModal);

		return newModal;
	}

	// We don't want to display the modal if a loading overlay is active
	// or another modal is loading so we use this to check it
	function canDisplayModal() {
		// TODO: 	Check if another modal is loading
		// 			And try to add a delay after loading screen is gone
		return !fullPageLoadingActive();
	}
}

export {createModal}
